// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__thxtS","iconWrapper":"logo_iconWrapper__aW6DR","icon":"logo_icon__RniHO","text":"logo_text__t6JVm"};